import { render, staticRenderFns } from "./modalDuplicarCupones.vue?vue&type=template&id=50bf611f&"
import script from "./modalDuplicarCupones.vue?vue&type=script&lang=js&"
export * from "./modalDuplicarCupones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports